<!-- Author ミィン -->
<!-- 委任状 -->

<template>
  <div v-show="show">
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t('general.add')}}
        </el-button>
      </el-form-item>

    </el-form>

    <!-- Table -->
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px"
      :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('attorney_power.employee_id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('attorney_power.trustee_name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.trustee_name}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('attorney_power.trustee_phone_no')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.trustee_phone_no}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('attorney_power.delegation_content')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.delegation_content }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('attorney_power.delegation_date')" align="center">
        <template slot-scope="scope">
          <!-- <div slot="reference" class="name-wrapper">
            <el-button type="text" @click="handleDetails(scope.$index, scope.row)">{{ scope.row.delegation_date }}
            </el-button>
          </div> -->
          <span>{{ scope.row.delegation_date}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t('general.edit')}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t('general.delete')}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t('general.print')}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- New -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="55%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">
        <el-collapse>
          <el-collapse-item :title="$t('general.general_info')" name="1" class="title">
            <el-row>
              <el-col>
                <div>
                  <el-form-item :label="$t('attorney_power.delegation_date')+':'" prop="delegation_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.delegation_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-11"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="delegation_content"
                    style="margin-left:50px">
                    <el-select prefix-icon="el-icon-edit" clearable v-model="ruleForm.delegation_content" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in delegation_contentList" :key="item.id" :label="item.name"
                        :value="item.value"></el-option>
                    </el-select>
                    <el-button class="el-icon-info" type="text" @click="open1">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_my_num"
                    style="margin-left:50px" v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.death_my_num" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_relation"
                    style="margin-left:50px" v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.death_relation" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_name"
                    style="margin-left:50px" v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.death_name" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_birth_date"
                    style="margin-left:50px" v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="other_content"
                    style="margin-left:50px" v-if="ruleForm.delegation_content === '８．その他 （委任する内容を具体的に記入してください）'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.other_content" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('attorney_power.period_amount_wished')+':'" prop="period_amount_wished"
                  style="margin-left:50px" label-width="500px">
                  <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.period_amount_wished" size="mini"
                    style="margin-left:10px;margin-right: 10px; "></el-checkbox>
                  <el-select prefix-icon="el-icon-edit" clearable v-model="ruleForm.kibou" size="mini"
                    style="margin-left:10px;width: 220px" :placeholder="$t('general.please_select')"
                    v-if="ruleForm.period_amount_wished === true">
                    <el-option v-for="item in kibouList" :key="item.id" :label="item.name" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-button class="el-icon-info" type="text" @click="open2"
                    v-if="ruleForm.period_amount_wished === true">{{$t('general.hint')}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('attorney_power.delegator')" name="2" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('attorney_power.employee_id')+':'" prop="employee_id"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id" style="margin-left:10px;margin-right:50px;width: 185px"
                      size="mini" :placeholder="$t('general.please_select')" @change="employeeIdSelected">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.name')+':'" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('attorney_power.trustee')" name="3" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('attorney_power.trustee_name')+':'" prop="trustee_name"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_name" size="mini"
                      style="margin-left:10px;width: 185px" placeholder></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.trustee_phone_no')+':'" prop="trustee_phone_no"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_phone_no" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="＜例＞：03-1234-5678"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.trustee_address')+':'" prop="trustee_address"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_address" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('attorney_power.address')"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('attorney_power.trustee_name_furi')+':'" prop="trustee_name_furi"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_name_furi" size="mini"
                      style="margin-left:10px;width: 185px" placeholder></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.trustee_postcode')+':'" prop="trustee_postcode"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_postcode" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="080-5555"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.relation_with_delegator')+':'" prop="relation_with_delegator"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.relation_with_delegator" size="mini"
                      style="margin-left:10px;width: 185px" placeholder></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="55%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">
        <el-collapse>
          <el-collapse-item :title="$t('general.general_info')" name="1" class="title">
            <el-row>
              <el-col>
                <div>
                  <el-form-item :label="$t('attorney_power.delegation_date')+':'" prop="delegation_date"
                    style="margin-left:50px">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.delegation_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-11"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="delegation_content"
                    style="margin-left:50px">
                    <el-select prefix-icon="el-icon-edit" clearable v-model="ruleForm.delegation_content" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in delegation_contentList" :key="item.id" :label="item.name"
                        :value="item.value"></el-option>
                    </el-select>
                    <el-button class="el-icon-info" type="text" @click="open1">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_my_num"
                    style="margin-left:50px" v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.death_my_num" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_relation"
                    style="margin-left:50px" v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.death_relation" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_name"
                    style="margin-left:50px" v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.death_name" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_birth_date"
                    style="margin-left:50px" v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="other_content"
                    style="margin-left:50px" v-if="ruleForm.delegation_content === '８．その他 （委任する内容を具体的に記入してください）'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.other_content" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('attorney_power.period_amount_wished')+':'" prop="period_amount_wished"
                  style="margin-left:50px" label-width="500px">
                  <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.period_amount_wished" size="mini"
                    style="margin-left:10px;margin-right: 10px; "></el-checkbox>
                  <el-select prefix-icon="el-icon-edit" clearable v-model="ruleForm.kibou" size="mini"
                    style="margin-left:10px;width: 220px" :placeholder="$t('general.please_select')"
                    v-if="ruleForm.period_amount_wished === true">
                    <el-option v-for="item in kibouList" :key="item.id" :label="item.name" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-button class="el-icon-info" type="text" @click="open2"
                    v-if="ruleForm.period_amount_wished === true">{{$t('general.hint')}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('attorney_power.delegator')" name="2" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('attorney_power.employee_id')+':'" prop="employee_id"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id" style="margin-left:10px;margin-right:50px;width: 185px"
                      size="mini" :placeholder="$t('general.please_select')" @change="employeeIdSelected">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.name')+':'" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('attorney_power.trustee')" name="3" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('attorney_power.trustee_name')+':'" prop="trustee_name"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_name" size="mini"
                      style="margin-left:10px;width: 185px" placeholder></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.trustee_phone_no')+':'" prop="trustee_phone_no"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_phone_no" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="＜例＞：03-1234-5678"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.trustee_address')+':'" prop="trustee_address"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_address" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('attorney_power.address')"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('attorney_power.trustee_name_furi')+':'" prop="trustee_name_furi"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_name_furi" size="mini"
                      style="margin-left:10px;width: 185px" placeholder></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.trustee_postcode')+':'" prop="trustee_postcode"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_postcode" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="080-5555"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.relation_with_delegator')+':'" prop="relation_with_delegator"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.relation_with_delegator" size="mini"
                      style="margin-left:10px;width: 185px" placeholder></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <!-- Detail -->
    <el-dialog :title="$t('general.detail')" :append-to-body="true" :visible.sync="dialogDetails" width="55%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">
        <el-collapse>
          <el-collapse-item :title="$t('general.general_info')" name="1" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('attorney_power.delegation_date')+':'" prop="delegation_date">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.delegation_date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                      placeholder="2020-03-11" readonly="readonly"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="delegation_content">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.delegation_content" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_my_num"
                    v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.death_my_num" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_relation"
                    v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.death_relation" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_name"
                    v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.death_name" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="death_birth_date"
                    v-if="ruleForm.delegation_content === '５．死亡に関する手続きについて'">
                    <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.date" size="mini"
                      value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" readonly="readonly" type="date">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="other_content"
                    v-if="ruleForm.delegation_content === '８．その他 （委任する内容を具体的に記入してください）'">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.other_content" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.period_amount_wished')+':'" prop="period_amount_wished">
                    <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.period_amount_wished" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly" disabled></el-checkbox>
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.kibou" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('attorney_power.delegator')" name="2" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('attorney_power.delegation_content')+':'" prop="employee_id">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.employee_id" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.name')+':'" prop="name">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('attorney_power.trustee')" name="3" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('attorney_power.trustee_name')+':'" prop="trustee_name">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_name" size="mini"
                      style="margin-left:10px;width: 185px" placeholder readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.trustee_phone_no')+':'" prop="trustee_phone_no">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_phone_no" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="08071345555" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.trustee_address')+':'" prop="trustee_address">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_address" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('attorney_power.address')"
                      readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('attorney_power.trustee_name_furi')+':'" prop="trustee_name_furi">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_name_furi" size="mini"
                      style="margin-left:10px;width: 185px" placeholder readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.trustee_postcode')+':'" prop="trustee_postcode">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.trustee_postcode" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="080-5555" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('attorney_power.relation_with_delegator')+':'"
                    prop="relation_with_delegator">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.relation_with_delegator" size="mini"
                      style="margin-left:10px;width: 185px" placeholder readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="cancel()" type="primary" size="medium">{{$t('general.cancel')}}
        </el-button>
      </span>
    </el-dialog>

    <br />

    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        delegation_contentList: [{
            id: 1,
            name: "１．年金の加入期間について",
            value: "１．年金の加入期間について",
          },
          {
            id: 2,
            name: "２．年金の見込額について",
            value: "２．年金の見込額について",
          },
          {
            id: 3,
            name: "３．年金の請求について",
            value: "３．年金の請求について",
          },
          {
            id: 4,
            name: "４．各種再交付手続きについて（裏面の《来所時等の注意事項》をご確認ください）",
            value: "４．各種再交付手続きについて（裏面の《来所時等の注意事項》をご確認ください）",
          },
          {
            id: 5,
            name: "５．死亡に関する手続きについて",
            value: "５．死亡に関する手続きについて",
          },
          {
            id: 6,
            name: "６．国民年金の加入手続きについて",
            value: "６．国民年金の加入手続きについて",
          },
          {
            id: 7,
            name: "７．国民年金保険料の納付、免除、学生納付特例制度等について",
            value: "７．国民年金保険料の納付、免除、学生納付特例制度等について",
          },
          {
            id: 8,
            name: "８．その他 （委任する内容を具体的に記入してください）",
            value: "８．その他 （委任する内容を具体的に記入してください）",
          },
        ],
        kibouList: [{
            id: 1,
            name: "Ａ．受任者に交付を希望する",
            value: "Ａ．受任者に交付を希望する",
          },
          {
            id: 2,
            name: "Ｂ．本人あて郵送を希望する",
            value: "Ｂ．本人あて郵送を希望する",
          },
        ],
        ruleForm: {
          id: "",
          delegation_date: "",
          trustee_name_furi: "",
          trustee_name: "",
          relation_with_delegator: "",
          trustee_postcode: "",
          trustee_phone_no: "",
          trustee_address: "",
          delegation_content: "",
          other_content: "",
          period_amount_wished: false,
          kibou: "",
          death_my_num: "",
          death_relation: "",
          death_name: "",
          death_birth_date: "",
          employee_id: "",
          name: "",
        },
        rules: {
          employee_id: [{
            required: true,
            message: this.$t("attorney_power.enter_employee_id"),
            trigger: "blur",
          }, ],
          trustee_phone_no: [{
              trigger: "blur",

              pattern: /^(?:|\d{3}-\d{3}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4})$/,
              message: this.$t("companyInfo.filltel"),
            },

          ],
        },
        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        dialogDetails: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,
        empList: [],
        empList1: [],
        emp: {
          id: "",
          employee_id: "",
          name: "",
          name_rm: "",
          name_frgn: "",
          post_code: "",
          birthday: "",
          birthday: "",
          gender: "",
          email: "",
          mynum: "",
          work_status: "",
          begin_date: "",
          end_date: "",
          cause: "",
          employee_type: "",
          title: "",
          work_content: "",
          address1: "",
          address2: "",
          address3: "",
          address_kn1: "",
          address_kn2: "",
          address_kn3: "",
          tel: "",
          bank_name: "",
          bank_branch: "",
          deposit_type: "",
          account: "",
          account_name: "",
          emp_insuranceID: "",
          emp_ins_begin_day: "",
          emp_ins_end_day: "",
          pensionID: "",
          health_insuranceID: "",
          basic_pensionID: "",
          salary_changeday: "",
          salary_month: "",
          commuting_fee: "",
          nation: "",
          resident: "",
          resident_code: "",
        },
      };
    },
    methods: {
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open("/pdf/委任状-" + "uid=" + uid + ".pdf");
      },
      employeeIdSelected() {
        // console.log(this.ruleForm.employee_id);
        let postData = this.qs.stringify({
          employee_id: this.ruleForm.employee_id,
        });
        this.axios({
            method: "post",
            url: "/ListEmpList",
            data: postData,
          })
          .then((response) => {
            // console.log(response.data);
            this.empList1 = response.data;
            this.ruleForm.name = this.empList1[0].name;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      open1() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("attorney_power.delegation_content"),
          message: h(
            "i", {
              style: "color: teal",
            },
            this.$t("attorney_power.hint_open1")
          ),
        });
      },
      open2() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("attorney_power.kibou"),
          message: h(
            "i", {
              style: "color: teal",
            },
            this.$t("attorney_power.hint_open2")
          ),
        });
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id,
        });
        this.axios({
            method: "post",
            url: "/AttorneyPowerPDF",
            data: postData,
          })
          .then((response) => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed"),
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 700);
            // console.log(response);
          })
          .catch((error) => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
            console.log(error);
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDetails(index, row) {
        this.dialogDetails = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: "OK",
            cancelButtonText: this.$t("general.cancel"),
            type: "warning",
          })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id,
            });
            this.axios({
                method: "post",
                url: "/deleteAttorneyPower",
                data: postData,
              })
              .then((response) => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageAttorneyPower")
                  .then((response) => {
                    this.tableData = response.data;
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled"),
            });
          });
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: this.$t("general.confirm"),
            cancelButtonText: this.$t("general.cancel"),
            type: "warning",
          })
          .then((_) => {
            this.emptyUserData();
            done();
          })
          .catch((_) => {});
      },
      handleCurrentChange() {
        // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
        let postData = this.qs.stringify({
          page: this.currentPage,
        });
        this.axios({
            method: "post",
            url: "/pageAttorneyPower",
            data: postData,
          })
          .then((response) => {
            this.tableData = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
        this.$refs[formName].resetFields();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          delegation_date: "",
          trustee_name_furi: "",
          trustee_name: "",
          relation_with_delegator: "",
          trustee_postcode: "",
          trustee_phone_no: "",
          trustee_address: "",
          delegation_content: "",
          other_content: "",
          period_amount_wished: false,
          kibou: "",
          death_my_num: "",
          death_relation: "",
          death_name: "",
          death_birth_date: "",
          employee_id: "",
          name: "",
        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              delegation_date: this.ruleForm.delegation_date,
              trustee_name_furi: this.ruleForm.trustee_name_furi,
              trustee_name: this.ruleForm.trustee_name,
              relation_with_delegator: this.ruleForm.relation_with_delegator,
              trustee_postcode: this.ruleForm.trustee_postcode,
              trustee_phone_no: this.ruleForm.trustee_phone_no,
              trustee_address: this.ruleForm.trustee_address,
              delegation_content: this.ruleForm.delegation_content,
              other_content: this.ruleForm.other_content,
              period_amount_wished: this.ruleForm.period_amount_wished,
              kibou: this.ruleForm.kibou,
              death_my_num: this.ruleForm.death_my_num,
              death_relation: this.ruleForm.death_relation,
              death_name: this.ruleForm.death_name,
              death_birth_date: this.ruleForm.death_birth_date,
              employee_id: this.ruleForm.employee_id,
            });
            this.axios({
                method: "post",
                url: "/insertAttorneyPower",
                data: postData,
              })
              .then((response) => {
                this.axios
                  .post("/pageAttorneyPower")
                  .then((response) => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.s1_cancel(ruleForm);
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed"),
                    });
                  })
                  .catch((error) => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed"),
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message.error('必須項目が入力されていません');
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              delegation_date: this.ruleForm.delegation_date,
              trustee_name_furi: this.ruleForm.trustee_name_furi,
              trustee_name: this.ruleForm.trustee_name,
              relation_with_delegator: this.ruleForm.relation_with_delegator,
              trustee_postcode: this.ruleForm.trustee_postcode,
              trustee_phone_no: this.ruleForm.trustee_phone_no,
              trustee_address: this.ruleForm.trustee_address,
              delegation_content: this.ruleForm.delegation_content,
              other_content: this.ruleForm.other_content,
              period_amount_wished: this.ruleForm.period_amount_wished,
              kibou: this.ruleForm.kibou,
              death_my_num: this.ruleForm.death_my_num,
              death_relation: this.ruleForm.death_relation,
              death_name: this.ruleForm.death_name,
              death_birth_date: this.ruleForm.death_birth_date,
              employee_id: this.ruleForm.employee_id,
            });
            this.axios({
                method: "post",
                url: "/updateAttorneyPower",
                data: postData,
              })
              .then((response) => {
                this.handleCurrentChange();
                // this.s1_cancel(ruleForm);
                this.cancel();
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed"),
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message.error('必須項目が入力されていません');
            return false;
          }
        });
      },
      getPages() {
        this.axios
          .post("/rowsAttorneyPower")
          .then((response) => {
            this.total = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      },
    },
    created() {
      this.axios
        .post("/pageAttorneyPower")
        .then((response) => {
          // console.log(response.data);
          this.show = true
          this.tableData = response.data;
        })
        .catch((error) => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });

      this.axios
        .post("/rowsAttorneyPower")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.axios
        .post("/ListEmpListForInsNameChange")
        .then((response) => {
          // console.log(response.data);
          this.empList = response.data;
          // console.log(this.empList);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  };
</script>

<style scoped>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>

<style scoped>
  .search_name {
    width: 200px;
  }

  .item1 {
    visibility: hidden;
  }

  .item2 {
    visibility: hidden;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/SocialIns/AttoneryPower.vue